<template>
  <div :class="[$style.tree]">
    <div :class="[$style.h100, 'lnb-nav']">
      <!-- 검색 영역 -->
      <div class="search">
        <w-search-field @search="filterTree"/>
      </div>
      <!-- 트리 영역 -->
      <article class="category-item">
        <el-scrollbar slot="topContent" class="tree-wrapper">
          <el-tree :ref="treeRef" :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :render-content="renderContent" :expand-on-click-node="false" highlight-current @node-click="clickNode" :filter-node-method="filterNode">
          </el-tree>
        </el-scrollbar>
      </article>
    </div>
    <el-row type="flex" justify="center" align="middle" :class="$style['btn-bar']">
      <div>
        <el-button-group>
          <el-button @click="onAddFilter">필터 추가</el-button>
          <el-button :disabled="!(selectedNode.leaf && selectedNode.type === 'user')" @click="onUpdateFilter">필터 편집</el-button>
        </el-button-group>
      </div>
    </el-row>
    <w-log-filter-add-popup v-loading="loading" ref="filterAddPopup"
    :search-tags="searchTags"
    :field-options="selectOptions"
    @change-tree-data="loadCustomFilterData" />
    <w-log-filter-update-popup ref="filterUpdatePopup"
    :search-tags="searchTags"
    :field-options="selectOptions"
    @change-tree-data="loadCustomFilterData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MsgUtil from '@/utils/message';
import RouterTree from '@/mixins/router/tree';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps, rootNode, treeType } from '@/constants/tree';
import LogAPI from '@/api/log/common';

import WSearchField from '@/components/form/SearchField';
import WLogFilterUpdatePopup from './popup/LogFilterSettingPopup';
import WLogFilterAddPopup from './popup/LogFilterAddPopup';


export default {
  name: 'WLogTree',
  mixins: [RouterTree, TreeFilter],
  props: {
    searchTags: {
      typs: Array,
      default: null,
    },
    selectOptions: Array,
  },
  components: {
    WSearchField,
    WLogFilterUpdatePopup,
    WLogFilterAddPopup,
  },
  data() {
    return {
      treeType: treeType.LOG,
      defaultProps,
      loading: false,
    };
  },
  computed: mapGetters(['selectedNode']),
  created() {
    this.loadData();
  },
  methods: {
    deleteCustomFilter(node) {
      const params = { filterId: node.data.filterId };
      this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.DELETE)).then(() => {
        LogAPI.deleteLogFilter(params).then((response) => {
          if (response.data.success) {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.DELETE, '필터', true));
            const treeKey = rootNode.treeKey;
            this.routeByTreeKey(this.concatTreeTypeAndTreeKey(treeKey));
            this.loadData();
          }
        }).catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.DELETE, '필터', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
    renderContent(h, { node, data }) {
      if (data.leaf && data.type === 'user') {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon mini content-margin-r mr-r4">
                <span on-click={() => this.deleteCustomFilter(node)}><i class="far fa-minus-circle"></i></span>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      }
      return (
        <span class="el-tree-node__label" >
          <span>
            <span>{data.label}</span>
          </span>
        </span>
      );
    },
    clickNode(nodeData) {
      this.routeByTreeKey(this.concatTreeTypeAndTreeKey(nodeData[this.defaultProps.treeKey]));
    },
    loadData() {
      this.loading = true;
      LogAPI.getLogTree().then((response) => {
        if (response.data.success) {
          this.treeData = [response.data.children];
        } else {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.actiion.VIEW, '로그 트리 정보', false));
        }
      }).catch((e) => {
        this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '로그 트리 정보', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    loadCustomFilterData() {
      this.loadData();
    },
    onAddFilter() {
      this.$refs.filterAddPopup.open();
    },
    onUpdateFilter() {
      this.$refs.filterUpdatePopup.open();
    },
  },
};
</script>

<style module>
.h100 {
  height: 100%;
}
.tree {
  height: calc(100% - 95px) !important;
}
.btn-bar {
  border-top: 1px solid #F0F0F0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/log/components/LogTree.vue